module.exports = __webpack_public_path__ + "static/media/cvappnew.450b81ed.mp4";